import { IconComponent } from './types';

const ThinCheckIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={8}
    viewBox="0 0 10 8"
    fill="none"
    {...props}
  >
    <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" />
  </svg>
);
export default ThinCheckIcon;
